import { deploymentEnvKeys } from "~/lib/envSelector/envSource";

const hasTracEnabled = true;
const ciamTenant = "gsp-invesco";

export default function (env) {
  return {
    customer: "gspinvesco",
    ciamTenant,
    tracFeatures: {
      tracEnabled: hasTracEnabled,
    },
    institutionInvestor: true,
    serviceUserBusinessName: "Invesco",
    registrar: "ta2000",
    production: false,
    II: {
      addNewUser: {
        salutationNotRequired: true,
      },
      printEnabled: true,
    },
    graphqlServer: deploymentEnvKeys.includes(env)
      ? `https://apollo${env == "prod" ? "" : "-" + env}.ssnc.cloud`
      : "",
    cmsType: "S3",
    mock: {
      enabledByDefault: false,
      redirectMissingMocksToReal: true,
    },
    paths: {
      middleTier: "/api",
      auth: "/",
    },
    encryption: {
      key: "U2FsdGVkX19Hl1nA1ECK+spE0U+jPyRBgMIjOuS5hRk=",
      enabled: false,
    },
    network: {
      delay: 0,
      outputDiagnotics: true,
      retriesGet: 2,
    },
    auth: {
      skipReAuthRequests: false,
      userUnauthenticatedRedirectRoute: "",
      useIam: true,
    },
    features: ["user-account", "sign-up", "accounts", "forgot-credentials"],
    dates: {
      dateFormat: "MM/dd/yyyy",
      timeFormat: "h:mm a",
      dateRangeFormat: "MM/DD/YYYY",
      dateTimeFormat: "MM/DD/YYYY hh:mm a",
      dateRangeWithTimeFormat: "MM/DD/YYYY hh:mm a",
      prettyDateFormat: "MMM dd yyyy",
    },
    sessionTimeout: {
      timeoutsEnabled: true,
      warnUserAfterSeconds: 13 * 60, // 13 mins
      timeoutAfterSeconds: 2 * 60, // 2 mins
      serverKeepaliveEnabled: true,
      serverKeepaliveIntervalSeconds: 60,
    },
    custom: {
      directDebitMandate: {
        bankOrBuildingSocietyAddress: {
          addressLine1: undefined,
          addressLine2: undefined,
          addressLine3: undefined,
        },
        bankOrBuildingSocietyName: "Invesco Investment Services, Inc.",
        GIAServiceUserNumber: undefined,
        ISAServiceUserNumber: undefined,
      },
      newLandingPageUI: true,
      cookiesUrl: "https://www.invesco.com/legalinfo/",
      termsUrl: "https://www.invesco.com/termsofuse/",
      policyUrl: "https://www.invesco.com/privacypolicy/",
      internalOrgId: "00000000-0000-0000-0000-000000000000",
      allowedClientSources: ["TA2000"],
      canAddDuplicateReference: true,
      dealingSettings: {
        hideIncomePreferenceColumn: true,
      },
      userNameDisplayFormat: ["title", "fullName"],
      unitPriceFormat: "money",
      unifiedOpenNewAccountUrl:
        "https://bfwebqat.bfwebsolutions.com/BFWeb/clients/invesco/gspnasu",
      unifiedAccountDetailsEndpoint:
        env == "uat"
          ? "https://bfwebuat.bfwebsolutions.com/BFWeb/jwtlink/invesco"
          : env == "prod"
          ? "https://stage.secureaccountview.com/BFWeb/jwtlink/invesco"
          : "https://bfwebqat.bfwebsolutions.com/BFWeb/jwtlink/invesco",
      unifiedMarketingWidgetEndpoint:
        "https://www.ssctech.com/solutions/by-industry/asset-management",
      unifiedDocumentsGuideEndpoint:
        "https://www.secureaccountview.com/clients/invesco/pdf/HowToReadStatement010519.pdf",
      resetPasswordEndpoint: `https://identity-server-dev.ssnc.cloud/${ciamTenant}/Account/ForgotPassword`,
      helpCenterRedirectionUrl: `https://www.invesco.com/us/en/Individual-investor/contact-us.html?audienceRole=IndividualInvestor`,
      unifiedUI: true,
      unifiedPortfolioLayout: {
        // | Rows/Cols | Col1                   |
        // | --------- | ---------------------- |
        // | Row1      | Total Portfolio        |
        // | Row2      | Accounts               |
        // | Row3      | Documents              |
        // | Row4      | Recent Transactions    |
        // | Row4      | Promo                  |
        mobile: {
          portfolio_total_assets: 1,
          accounts: 2,
          documents: 3,
          recent_transactions: 4,
          promo: 5,
        },
        // | Rows/Cols | Col1                | Col2      |
        // | --------- | ------------------- | --------- |
        // | Row1      | Total Portfolio     | Documents |
        // | Row2      | Accounts            |
        // | Row3      | Recent Transactions | Promo     |
        desktop: {
          portfolio_total_assets: {
            rowStart: 1,
            rowEnd: 1,
            colStart: 1,
            colEnd: 1,
          },
          documents: { rowStart: 1, rowEnd: 1, colStart: 2, colEnd: 2 },
          accounts: { rowStart: 2, rowEnd: 2, colStart: 1, colEnd: 3 },
          recent_transactions: {
            rowStart: 3,
            rowEnd: 3,
            colStart: 1,
            colEnd: 1,
          },
          promo: { rowStart: 3, rowEnd: 3, colStart: 2, colEnd: 2 },
        },
      },
      unifiedNonRetailPortfolioLayout: {
        mobile: {
          portfolio_summary: 1,
          alerts: 2,
          approvals_summary: 3,
          accounts: 4,
        },
        desktop: {
          portfolio_summary: {
            rowStart: 1,
            rowEnd: 1,
            colStart: 1,
            colEnd: 1,
          },
          alerts: { rowStart: 1, rowEnd: 1, colStart: 2, colEnd: 2 },
          approvals_summary: {
            rowStart: 2,
            rowEnd: 2,
            colStart: 1,
            colEnd: 3,
          },
          accounts: { rowStart: 3, rowEnd: 3, colStart: 1, colEnd: 3 },
        },
      },
      ta2000Features: {
        headers: {
          fundSponsorId: "525",
          securityChannel: "ta-shd",
          system: "mfb",
          tenant: "invescoshareholder",
          apiKey: "5f63f6e2203e40eab664fa86bd81431c",
        },
      },
      bulkUserUpload: true,
      resendRegistrationLink: true,
    },
  };
}
